export const StatusPaleBGPaletteDark: any = {
    1: '#71C3EC',
    2: '#71C3EC',
    3: '#71C3EC',
    4: '#71C3EC',
    5: '#80e099',
    6: '#80e099',
    7: '#E1938D',
    8: '#D77BC6',
    9: '#F0B17D',
    10: '#BFAAFF',
    11: '#878788',
    12: '#878788',
}